import React from 'react';

import { Outlet } from 'react-router';

import { PageLayout } from 'src/components/common';
import { PeoPayrollProvidersDetailLayout } from 'src/layouts/PeoPayrollProvidersDetailLayout';
import { SxProp } from 'src/types/mui';

export const PeoPayrollProvidersDetailOutlet: React.FC = () => {
  return (
    <PageLayout
      titleContent="PEO Payroll Provider Details"
      paperSx={{ mt: 5 }}
      containerSx={pageLayoutContainerSx}
    >
      <PeoPayrollProvidersDetailLayout>
        <Outlet />
      </PeoPayrollProvidersDetailLayout>
    </PageLayout>
  );
};

const pageLayoutContainerSx: SxProp = {
  overflow: 'inherit',
};
